import classNames from 'classnames'
import { Input } from 'components/atom/Input'
import { TextArea, TextAreaContent } from 'components/atom/TextArea'
import { CircularCheckbox } from 'components/CircularCheckbox'
import { ShadowBox } from 'components/ShadowBox'
import { TextTypeAiScriptDisplay } from 'pages/content-video-editor/components/shortvideo/TextTypeAiScriptDisplay'
import useGetLanguages from 'hooks/useGetLanguages'
import useGetSourceType from 'hooks/useGetSourceType'
import useGetVoiceLanguageGroup from 'hooks/useGetVoiceLanguageGroup'
import React, {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useEffect,
  useState,
} from 'react'
import { isMobile } from 'react-device-detect'
import { Controller, useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { SourceType, TextTypeVideoInfo, VoiceTagType } from 'service/list'
import useUserStore from 'store/useUserStore'
import { getLocalStorage, saveLocalStorage, styles } from 'utils/common'
import { contentVideoTextTypeFormValues } from 'utils/type'
import TextCashUseModal from './TextCashUseModal'
import { useGetMyPoint } from 'hooks/query/point/useGetMyPoint'
import { Modal } from 'components/layout/Modal'

import { VideoRatioType } from '../shortvideo/VideoRatioType'
import { LocalImageUpload } from '../ImageUploadBox/local-image-upload'
import { ReactComponent as TrashIcon } from 'svg/fi_trash-2.svg'
import { useUploadFile } from 'hooks/query/s3/useUploadFile'
import { toast } from 'react-toastify'
import useDeleteFile from 'hooks/query/s3/useDeleteFile'
import {
  isInvalidFileExtension,
  setDefaultValueFromListInTextvideo,
  splitTextIntoScenes,
} from 'pages/content-video-editor/utils'
import { SubtitleDisplay } from './SubtitleDisplay'
import { useGetSubtitleShort } from 'hooks/query/useGetSubtitle'
import useGetSubtitleColor from 'hooks/query/useGetSubtitleColor'
import useGetUserVoice from 'hooks/query/useGetUserVoice'

interface TextTypeProps {
  tab: 'link' | 'text'
  setTab: Dispatch<SetStateAction<'link' | 'text'>>
  changeTab: (string: 'link' | 'text') => void
  voiceTags: VoiceTagType | undefined
}

export const TextType = ({
  tab,
  setTab,
  changeTab,
  voiceTags,
}: PropsWithChildren<TextTypeProps>) => {
  const { mutateAsync: uploadFileMutate, isPending } = useUploadFile()
  const { mutateAsync: deleteMutate } = useDeleteFile()

  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm<contentVideoTextTypeFormValues>({
    defaultValues: {
      idea: '',
      title: '',
      userWritten: 0,
      sourceType: '',
      languageId: 0,
      voiceId: 0,
      userVoiceId: 0,
      sourceTypeId: 0,
      amount: 0,
      withShort: 0,
      subtitleId: 0,
      subtitleColorId: 0,
    },
  })

  const [textVideoInfo, setTextVideoInfo] = useState<TextTypeVideoInfo>({
    idea: '',
    title: '',
    userWritten: 0,
    voiceId: 0,
    userVoiceId: 0,
    sourceType: '',
    sourceTypeId: 0,
    languageId: 0,
    amount: 0,
    subtitleColorId: 0,
    subtitleId: 0,
    withShort: 0,
    urls: [],
  })

  const PRODUCT_NAME_PATTERN = /^[^<>\uD800-\uDFFF]*$/
  const userInfo = useUserStore((state: any) => state.userInfo)
  const navigate = useNavigate()
  const [textVideoPriceInfo, setTextVideoPriceInfo] = useState<{
    voicePrice: number
    sourceTypePrice?: number
    subtitlePrice: number
  }>({
    voicePrice: 0,
    subtitlePrice: 0,
  })
  const [subtitleTooltip, setSubtitleTooltip] = useState<boolean>(false)
  const [saveSuccessModal, setSaveSuccessModal] = useState<boolean>(false)
  const [isUseModal, setUseModal] = useState<boolean>(false)
  const [isErrorModal, setIsErrorModal] = useState<boolean>(false)
  const [isSceneErrorModal, setIsSceneErrorModal] = useState<boolean>(false)
  const [errorTitle, setErrorTitle] = useState(<></>)
  const [errorSubtitle, setErrorSubtitle] = useState(<></>)

  const [selectedSourceType, setSelectedSourceType] =
    useState<SourceType | null>(null)
  const [selectedSourceTypeChildrenId, setSelectedSourceTypeChildrenId] =
    useState<number>(0)
  const [uploadImages, setUploadImages] = useState<
    {
      id: number
      file: File
      preview: string
      uploading: boolean
    }[]
  >([])

  const [selectedUploadImages, setSelectedUploadImages] = useState(
    new Array(uploadImages.length).fill(true),
  )

  const [userWritten, setUserWritten] = useState<boolean>(false)
  const [maxLength, setMaxLength] = useState<number>(1000)

  // 데이터
  const { data: sourceTypeList } = useGetSourceType()
  const { data: languageList } = useGetLanguages()
  const { data: myPointData, refetch: getMyPointRefetch } = useGetMyPoint()
  const { data: voiceList, refetch: voiceRefetch } = useGetVoiceLanguageGroup(
    watch('languageId'),
  )
  const { data: userVoiceList, refetch: userVoiceRefetch } = useGetUserVoice()

  const { data: subTitleList } = useGetSubtitleShort()
  const { data: subtitleColorList } = useGetSubtitleColor()

  const userCheck = (userInfo: any) => {
    if (!userInfo) {
      navigate('/sign-up')
      return
    }
  }
  const handleInitData = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    setUploadImages([])

    setValue('idea', '')
    setValue('title', '')
  }
  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (!event.target.files) return

    const MAX_FILE_SIZE_MB = 20
    const selectedFiles = Array.from(event.target.files)
    const originalFile = selectedFiles[0]

    const ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png']
    if (isInvalidFileExtension(originalFile.name, ALLOWED_EXTENSIONS)) {
      toast.error(
        `❌ ${originalFile.name}은(는) 허용되지 않는 파일 형식입니다.`,
        {
          position: 'bottom-center',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        },
      )
      return
    }

    const fileSizeMB = originalFile.size / (1024 * 1024)
    if (fileSizeMB > MAX_FILE_SIZE_MB) {
      toast.error(
        `❌ ${originalFile.name}은(는) ${MAX_FILE_SIZE_MB}MB 초과 파일입니다.`,
        {
          position: 'bottom-center',
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        },
      )
      return
    }

    const tempId = Date.now() + Math.random()
    const tempPreview = URL.createObjectURL(originalFile)
    setUploadImages((prev) => [
      ...prev,
      {
        file: originalFile,
        preview: tempPreview,
        uploading: true,
        id: tempId,
      },
    ])

    try {
      const { fileUrl } = await uploadFileMutate(originalFile)
      setUploadImages((prev) =>
        prev.map((item) =>
          item.id === tempId
            ? {
                ...item,
                preview: fileUrl,
                uploading: false,
              }
            : item,
        ),
      )
    } catch (error) {
      toast.error(
        `❌ ${originalFile.name}은(는) upload에 실패했습니다. 다시 시도해주세요!`,
        {
          position: 'bottom-center',
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        },
      )
      console.error(error)
    } finally {
      URL.revokeObjectURL(tempPreview)
      event.target.value = ''
    }
  }
  const getFileKey = (file: File) =>
    `${file.name}_${file.size}_${file.lastModified}`
  const handleDeleteFile = async (targetFile: File, targetUrl: string) => {
    const targetKey = getFileKey(targetFile)

    setUploadImages((prev) =>
      prev.filter((imgObj) => imgObj.preview !== targetUrl),
    )
    await deleteMutate(targetUrl)
    setSelectedUploadImages((prev) => {
      const targetIndex = uploadImages.findIndex(
        (imgObj) => getFileKey(imgObj.file) === targetKey,
      )
      if (targetIndex === -1) return prev
      const newSelected = [...prev]
      newSelected.splice(targetIndex, 1)
      return newSelected
    })
  }

  const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    document.getElementById('file-input')!.click()
  }

  const onSubmit = (data: any) => {
    console.log(data)
    userCheck(userInfo)
    // localstorage에 데이터 저장
    let {
      idea,
      title,
      userWritten,
      sourceType,
      sourceTypeId,
      languageId,
      voiceId,
      userVoiceId,
      withShort,
      subtitleId,
      subtitleColorId,
    } = data

    const prevInfo = {
      idea,
      title,
      sourceType,
      sourceTypeId,
      languageId,
      voiceId,
      userVoiceId,
      subtitleId,
      subtitleColorId,
      withShort,
    }
    //! 제일 첫번째 내가쓴 대본입력했을 경우 4문단이 나오는지 확인 필요
    if (userWritten) {
      const scenes = splitTextIntoScenes(idea, 4)
      const scenesLength = scenes.length
      console.log(scenes, scenesLength)
      if (scenesLength < 4) return setIsSceneErrorModal(true)
    }

    saveLocalStorage('contentTextVideoData', prevInfo)

    //sourceType이 이미지 업로드, sourceTypeId가 3일때 사진4장 확인

    if (sourceTypeId === 3 && uploadImages.length !== 4) {
      setErrorTitle(
        <p className="text-[18px] font-bold">
          🚨 이미지 4장을 업로드 해주세요!
        </p>,
      )
      setErrorSubtitle(
        <p className="text-[14px]">
          이미지 업로드 기능을 사용하시려면 <br /> 반드시 이미지 4장을
          업로드해주세요!
        </p>,
      )
      setIsErrorModal(true)
      return
    } else if (Number(voiceId) === 0 && Number(userVoiceId) === 0) {
      setErrorTitle(
        <p className="text-[18px] font-bold">🚨 목소리를 선택해주세요!</p>,
      )
      setErrorSubtitle(
        <p className="text-[14px]">반드시 목소리를 선택해주세요!</p>,
      )
      setIsErrorModal(true)
      return
    }

    // 파일 확인
    const selectedUploadImageData = uploadImages.map((el) => el.preview)
    const urls = [...(selectedUploadImageData ?? [])]
    const files = selectedUploadImageData || []
    const textVideoData = {
      idea,
      subtitleId,
      subtitleColorId,
      title,
      userWritten,
      sourceType,
      languageId,
      sourceTypeId,
      voiceId,
      userVoiceId,
      amount: 0,
      urls,
      withShort,
    }
    // 가격 정보 및 계산(sourceType, 목소리)
    const voice = voiceList?.find((el) => el.id === watch('voiceId'))
    const userVoice = userVoiceList?.find(
      (el) => el.id === watch('userVoiceId'),
    )
    const subtitle = subTitleList?.find((el) => el.id === watch('subtitleId'))
    let voicePrice = 0
    if (voice) {
      voicePrice = voice.originPrice
      delete textVideoData.userVoiceId
    } else if (userVoice) {
      voicePrice = userVoice.originPrice
      delete textVideoData.voiceId
    }

    if (sourceTypeId === 4 || sourceTypeId === 5) {
      const [sourceTypeInfo] =
        sourceTypeList
          ?.filter((el) => el.id === 2)[0]
          .children?.filter((el) => el.id === sourceTypeId) ?? []
      setTextVideoPriceInfo({
        voicePrice: voicePrice,
        sourceTypePrice: Number(sourceTypeInfo.originPrice) ?? 0,
        subtitlePrice: Number(subtitle?.originPrice) ?? 0,
      })
    } else {
      setTextVideoPriceInfo({
        voicePrice: voicePrice,
        subtitlePrice: Number(subtitle?.originPrice) ?? 0,
      })
    }

    setTextVideoInfo(textVideoData)
    setUseModal(true)
  }

  useEffect(() => {
    const saveData: TextTypeVideoInfo = getLocalStorage('contentTextVideoData')
    if (saveData) {
      const {
        sourceType,
        sourceTypeId,
        languageId,
        voiceId,
        userVoiceId,
        subtitleColorId,
        subtitleId,
      } = saveData
      console.log('localstorage  exist!')
      if (sourceType) {
        setValue('sourceType', sourceType)
      }
      if (sourceTypeId) {
        setValue('sourceTypeId', sourceTypeId)
      }
      if (languageId && voiceId) {
        setValue('languageId', languageId)
        const voice = voiceList?.find((el) => (el.id = voiceId))
        if (voice) {
          setValue('voiceId', voice.id)
        }
      }
      if (languageId && userVoiceId) {
        setValue('languageId', languageId)
        const voice = userVoiceList?.find((el) => el.id === userVoiceId)

        if (voice) {
          setValue('userVoiceId', voice.id)
        }
      }
      if (subtitleId && subTitleList) {
        const subtitle = subTitleList?.find((el) => el.id === subtitleId)
        subtitle
          ? setValue('subtitleId', subtitle.id)
          : setDefaultValueFromListInTextvideo(
              subTitleList,
              setValue,
              'subtitleId',
            )
      } else {
        setDefaultValueFromListInTextvideo(subTitleList, setValue, 'subtitleId')
      }
      if (subtitleColorId && subtitleColorList) {
        const subtitleColor = subtitleColorList?.find(
          (el) => el.id === subtitleColorId,
        )
        subtitleColor
          ? setValue('subtitleColorId', subtitleColor.id)
          : setDefaultValueFromListInTextvideo(
              subtitleColorList,
              setValue,
              'subtitleColorId',
            )
      } else {
        setDefaultValueFromListInTextvideo(
          subtitleColorList,
          setValue,
          'subtitleColorId',
        )
      }
    } else {
      console.log('localstorage not exist!')
      if (sourceTypeList) {
        setValue('sourceType', sourceTypeList[0]?.name)
        setValue('sourceTypeId', sourceTypeList[0]?.id)
      }
      if (languageList) {
        setValue('languageId', languageList[0].id)
      }

      if (subTitleList) {
        setDefaultValueFromListInTextvideo(subTitleList, setValue, 'subtitleId')
      }
      if (subtitleColorList) {
        setDefaultValueFromListInTextvideo(
          subtitleColorList,
          setValue,
          'subtitleColorId',
        )
      }
      // if (voiceList) {
      //   setDefaultValueFromListInTextvideo(voiceList, setValue, 'voiceId')
      // }
    }
  }, [
    sourceTypeList,
    languageList,
    subtitleColorList,
    subTitleList,
    userVoiceList,
    ,
  ])

  return (
    <>
      <div className="relative mt-5 flex w-full flex-col">
        <div className="absolute z-40 flex h-[102px] w-full">
          <button
            className={classNames(
              'flex h-full w-[50%] items-start justify-center md:rounded-tl-[40px]',
              {
                'bg-[#2E343D] text-white': tab === 'link',
                'bg-[#EEF1F7] text-[#8F929B]': tab !== 'link',
              },
            )}
            type="button"
            onClick={() => {
              changeTab('link')
            }}
          >
            <span className="pt-5 text-[18px] font-bold">링크로 만들기</span>
          </button>
          <button
            className={classNames(
              'flex h-full w-[50%] items-start justify-center md:rounded-tr-[40px]',
              {
                'bg-[#2E343D] text-white': tab === 'text',
                'bg-[#EEF1F7] text-[#8F929B]': tab !== 'text',
              },
            )}
            onClick={() => {
              changeTab('text')
            }}
            type="button"
          >
            <span className="pt-5 text-[18px] font-bold">텍스트로 만들기</span>
          </button>
        </div>
        <form
          className={`z-50 mt-[60px] flex flex-col gap-[20px]`}
          onSubmit={handleSubmit(onSubmit, (err) => {
            console.log(err)
          })}
        >
          <ShadowBox className="flex flex-col gap-8 bg-[#FFFFFF] py-[40px] md:w-[816px]">
            <div className="flex flex-col">
              <div className="mb-4 flex w-full flex-col gap-[16px]">
                {' '}
                <div className="ml-4 flex w-[343px] flex-col md:ml-0 md:w-full">
                  <div className="relative w-[210px]">
                    <h3 className="text-[20px] font-bold text-[#2E343D] md:text-[24px]">
                      소재 입력
                    </h3>
                    {/* <ContentTooltip
                    setContentTooltipStatus={setContentTooltipStatus}
                    contentTooltipStatus={contentTooltipStatus}
                  /> */}
                  </div>
                  <p className="text-[14px] text-main">
                    영상으로 만들고 싶은 소재를 텍스트로 입력해주시면, AI가
                    20~40초 영상에 맞게 요약하거나 늘려서 대본을 생성해드려요.
                  </p>
                  <p className="text-[14px] text-error">
                    선정적이거나 폭력적인 내용, 유명인/어린이를 포함한 민감한
                    소재는 필터링 되어 별도의 경고 없이 생성 중단됩니다.
                  </p>
                  <div className="flex items-center gap-2">
                    <div className="flex items-center gap-2">
                      <label className="flex cursor-pointer items-center gap-2">
                        <div className="relative h-5 w-5 shrink-0">
                          <input
                            type="checkbox"
                            checked={userWritten}
                            onChange={(e) => {
                              const value: boolean = e.target.checked
                              setValue('userWritten', value ? 1 : 0)
                              value ? setMaxLength(400) : setMaxLength(1000)
                              setUserWritten(value)
                            }}
                            className="peer sr-only"
                          />

                          <span className="absolute inset-0 flex items-center justify-center rounded-[4px] bg-[#e4e7ec] before:text-white before:content-['✓'] peer-checked:bg-href peer-checked:before:text-xl"></span>
                        </div>

                        <span className="text-[#8F929B]">
                          내가 쓴 대본 그대로 사용
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="relative flex w-full flex-col items-center justify-center">
                <Controller
                  name={'idea'}
                  rules={{
                    required: {
                      value: true,
                      message: '소재 내용은 필수 입니다!',
                    },
                    maxLength: {
                      value: maxLength,
                      message: `소재내용의 길이가 ${maxLength}자를 넘습니다.`,
                    },
                    validate: (value) => {
                      return PRODUCT_NAME_PATTERN.test(value)
                        ? true
                        : '이모지와 꺽쇠괄호(< >)는 허용되지 않습니다.'
                    },
                  }}
                  render={({
                    field: { onBlur, value, ...field },
                    fieldState,
                  }) => {
                    return (
                      <>
                        {isMobile ? (
                          <TextArea
                            error={
                              value.length > maxLength ||
                              !PRODUCT_NAME_PATTERN.test(value)
                                ? true
                                : false
                            }
                            value={value}
                            {...field}
                            placeholder={
                              userWritten
                                ? ' [내가 쓴 대본을 입력하세요]  '
                                : ' [생성할 대본의 소재를 간단히 입력하세요] '
                            }
                            maxLength={maxLength}
                          />
                        ) : (
                          <TextAreaContent
                            error={
                              value.length > maxLength ||
                              !PRODUCT_NAME_PATTERN.test(value)
                                ? true
                                : false
                            }
                            value={value}
                            {...field}
                            placeholder={
                              userWritten
                                ? ' [내가 쓴 대본을 입력하세요]  '
                                : ' [생성할 대본의 소재를 간단히 입력하세요] '
                            }
                            maxLength={maxLength}
                          />
                        )}
                        <span
                          className={classNames(
                            'absolute bottom-9 right-5 z-50 text-[14px] text-[#8F929B] md:bottom-9 md:right-3',
                            {
                              'font-bold text-error':
                                watch('idea').length > maxLength,
                            },
                          )}
                        >
                          {`(${watch('idea').length}/${maxLength})`}
                        </span>

                        <div
                          className={`mt-[8px] flex w-full justify-start gap-[4px] ${
                            (value.length > maxLength ||
                              !PRODUCT_NAME_PATTERN.test(value)) &&
                            'text-error'
                          }`}
                        >
                          <span className="text-[14px] md:text-base">{`이모지, 한자(漢字), 꺽쇠괄호(< >) 는 허용되지 않습니다.`}</span>
                        </div>
                      </>
                    )
                  }}
                  control={control}
                />
              </div>
            </div>
            <div className="flex w-full flex-col items-center gap-[8px] md:w-[736px]">
              <div className="flex flex-col gap-[16px]">
                <div className="flex flex-col md:ml-0">
                  <div className="relative flex items-center gap-2">
                    {' '}
                    <h3 className="text-[20px] font-bold text-[#2E343D] md:text-[24px]">
                      영상 제목 입력
                    </h3>
                    {/* <ShortVideoTitleTooltip
                      setTitleTooltip={setTitleTooltip}
                      titleTooltip={titleTooltip}
                    /> */}
                  </div>

                  <p className="text-[14px] text-main">
                    조회수가 높아질 수 있게 매력적인 제목을 정해주세요!
                  </p>
                </div>
                <div className="flex w-full flex-col items-center gap-[8px] md:w-[736px]">
                  <div className="relative">
                    <Controller
                      render={({ field }) => (
                        <>
                          {isMobile ? (
                            <TextArea
                              userCheck={userCheck}
                              error={
                                field.value.length > 50 ||
                                !PRODUCT_NAME_PATTERN.test(field.value)
                                  ? true
                                  : false
                              }
                              {...field}
                              placeholder="영상 제목을 입력해주세요"
                              maxLength={50}
                            />
                          ) : (
                            <Input
                              userCheck={userCheck}
                              error={
                                field.value.length > 50 ||
                                !PRODUCT_NAME_PATTERN.test(field.value)
                                  ? true
                                  : false
                              }
                              {...field}
                              placeholder="영상 제목을 입력해주세요"
                              maxLength={50}
                            />
                          )}
                          <span className="absolute bottom-10 right-3 z-50 text-[14px] text-[#8F929B] md:bottom-[54%]">
                            {`(${watch('title').length}/50)`}
                          </span>
                          <div
                            className={`mt-[8px] flex gap-[4px] ${
                              (field.value.length > 50 ||
                                !PRODUCT_NAME_PATTERN.test(field.value)) &&
                              'text-error'
                            }`}
                          >
                            <span className="text-[14px] md:text-base">{`이모지, 한자(漢字), 꺽쇠괄호(< >) 는 허용되지 않습니다.`}</span>
                          </div>
                        </>
                      )}
                      name={'title'}
                      rules={{
                        required: {
                          value: true,
                          message: '컨텐츠 영상 제목은 필수입니다!',
                        },
                        maxLength: {
                          value: 90,
                          message: '유튜브 영상 제목의 길이가 50자를 넘습니다.',
                        },
                        validate:
                          watch(`title`) !== ''
                            ? (value) => {
                                return (
                                  PRODUCT_NAME_PATTERN.test(value) ||
                                  '이모지와 꺽쇠괄호(< >)는 허용되지 않습니다.'
                                )
                              }
                            : undefined,
                      }}
                      control={control}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* 영상 소스 */}
            <div className="flex w-full flex-col gap-4 px-4 md:px-0">
              <p className="text-[18px] font-bold">영상 소스</p>
              <div className="grid h-[240px] grid-cols-1 gap-x-1 md:h-[60px] md:grid-cols-3">
                {sourceTypeList?.map((sourceType, index) => (
                  <>
                    <button
                      className={classNames(
                        'h-[60px] rounded-[6px] border-[1px] border-[#D9DEE8] px-6 text-base font-bold md:h-auto',
                        {
                          'text-[#B6BBC6]':
                            watch('sourceType') !== sourceType.name,
                          'bg-main text-white':
                            watch('sourceType') === sourceType.name,
                        },
                      )}
                      type="button"
                      onClick={() => {
                        setValue('sourceType', sourceType?.name)
                        setValue('sourceTypeId', sourceType?.id)
                        setSelectedSourceType(sourceType)
                        setSelectedSourceTypeChildrenId(sourceType?.id)
                        const children = sourceType.children ?? []
                        if (children.length > 0) {
                          setSelectedSourceTypeChildrenId(children[0]?.id)
                          setValue('sourceTypeId', children[0]?.id)
                        }
                      }}
                    >
                      <CircularCheckbox
                        id={index}
                        onChange={() => {}}
                        label={sourceType.name}
                        checked={watch('sourceType') === sourceType.name}
                      />
                      {index === 0 && (
                        <img
                          src="assets/img/stock.png"
                          alt=""
                          className="ml-7 h-[18px] w-[133px]"
                        />
                      )}
                    </button>
                  </>
                ))}
              </div>
              {watch('sourceType') === 'AI 생성 이미지' && (
                <>
                  <div className="grid h-[80px] w-full grid-cols-2 rounded-[10px] bg-[#F6F8FB] px-5 py-4 md:h-[62px] md:py-0">
                    {sourceTypeList
                      ?.filter((el) => el.name === watch('sourceType'))[0]
                      ?.children?.map((el, index) => (
                        <>
                          <button
                            className="flex-col gap-1 md:flex md:flex-row md:items-center"
                            type="button"
                            onClick={() => {
                              setSelectedSourceTypeChildrenId(el.id)
                              setValue('sourceTypeId', el.id)
                            }}
                          >
                            {' '}
                            <CircularCheckbox
                              id={index}
                              onChange={() => {
                                setValue('sourceTypeId', el.id)
                              }}
                              label={el.name}
                              checked={watch('sourceTypeId') === el.id}
                            />
                            <s className="text-[14px] text-[#5E6068]">
                              {' '}
                              {Number(el.price).toLocaleString()}
                            </s>
                            {` `}
                            <span className="text-[14px] font-bold text-main">
                              {el.originPrice}캐시
                            </span>
                          </button>
                        </>
                      ))}
                  </div>
                </>
              )}
              {watch('sourceType') === '이미지 업로드' && (
                <>
                  {' '}
                  <div
                    style={{
                      background: '#F6F8FB',
                      borderRadius: '10px',
                      padding: '20px',
                    }}
                    className="custom-scroll max-h-[460px] overflow-y-scroll"
                  >
                    <div className="mb-1 text-[16px]">
                      <span className="font-bold">업로드한 이미지 </span>{' '}
                      <span className="text-[16px] text-sm text-[#8F929B]">
                        (각 5MB | jpg, jpeg, png)
                      </span>
                    </div>
                    <div className="mb-3 flex items-center space-x-2"></div>
                    <div
                      className={classNames('mb-5', {
                        'flex gap-1 overflow-x-auto': isMobile,
                        'grid grid-cols-8 gap-1': !isMobile,
                      })}
                    >
                      {/* local image upload 슬롯 */}
                      {uploadImages.map((el, index) => (
                        <div
                          key={index}
                          className={classNames('relative shrink-0 bg-black', {
                            'relative flex h-[151px] w-[85px] items-center justify-center overflow-hidden rounded-[4px] border-[1px] border-[#D9DEE8]':
                              isMobile,
                            'relative flex h-[152px] w-[85px] items-center justify-center overflow-hidden rounded-[4px] border-[1px] border-[#D9DEE8]':
                              !isMobile,
                          })}
                        >
                          {el.uploading && (
                            <div className="absolute inset-0 z-10 flex items-center justify-center bg-black bg-opacity-60">
                              <svg
                                className="h-6 w-6 animate-spin text-white"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <circle
                                  className="opacity-25"
                                  cx="12"
                                  cy="12"
                                  r="10"
                                  stroke="currentColor"
                                  strokeWidth="4"
                                />
                                <path
                                  className="opacity-75"
                                  fill="currentColor"
                                  d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 000 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
                                />
                              </svg>
                            </div>
                          )}
                          <img
                            src={el.preview}
                            alt={`img_${index + 1}`}
                            style={styles.image}
                          />
                          <div className="absolute right-1 top-1 z-50 flex cursor-pointer items-center active:scale-95">
                            <div
                              className={
                                'flex h-[28px] w-[28px] items-center justify-center rounded-full border-[1px] bg-[#2E343D]'
                              }
                            >
                              <button
                                className="flex h-[24px] w-[24px] items-center justify-center rounded-full bg-[#2E343D] font-bold text-white"
                                type="button"
                                onClick={() => {
                                  handleDeleteFile(el.file, el.preview)
                                }}
                              >
                                <TrashIcon />
                              </button>
                            </div>
                          </div>
                          <div className="absolute bottom-1 right-1 z-50 flex cursor-pointer items-center active:scale-95">
                            <div
                              className={
                                'flex h-[28px] w-[28px] items-center justify-center rounded-full border-2 border-href bg-white'
                              }
                            >
                              <div className="flex h-[22px] w-[22px] items-center justify-center rounded-full bg-href font-bold text-white">
                                {index + 1}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}

                      {/* local image 빈 슬롯 */}
                      {new Array(4 - (uploadImages.length ?? 0))
                        .fill(1)
                        .map((src, index) => (
                          <div key={index} className="cursor-pointer">
                            <div className="relative">
                              <LocalImageUpload
                                handleButtonClick={handleButtonClick}
                                index={index}
                                isPending={isPending}
                              />
                              <input
                                id="file-input"
                                type="file"
                                accept=".jpg,.jpeg,.png"
                                className="hidden"
                                onChange={handleFileChange}
                              />
                            </div>
                          </div>
                        ))}
                    </div>

                    {/* ㄴㄴ */}
                  </div>
                </>
              )}
            </div>
            <VideoRatioType />
            {/* <Upload
              watch={watch}
              setValue={setValue}
              control={control}
              userInfo={userInfo}
            /> */}
          </ShadowBox>

          <>
            <ShadowBox
              className={classNames('px-[16px] py-[40px] md:w-[816px]', {
                'pointer-events-none opacity-30': '',
              })}
            >
              <div className="flex w-[343px] flex-col gap-[40px] md:w-[736px] md:gap-0">
                <div className="relative mt-[16px] flex flex-col items-center md:mb-[40px]">
                  <p className="text-[24px] font-bold text-[#2E343D]">
                    효과 선택
                  </p>
                  <p className="text-[14px] text-main">
                    원하는 분위기의 영상 생성을 위해 각 효과를 선택해주세요!
                  </p>
                  {/* <div className="md:absolute  md:right-0 md:mt-0 mt-4 flex flex-col items-center">
                    <p className=" bg-clip-text text-transparent bg-gradient-to-r from-[rgba(96,149,255,1)] to-[rgba(213,18,231,1)]">
                      지금 놓치면 끝!
                    </p>
                    <p className="text-[#FD6767]">🔥 6/30 까지만</p>
                    <img
                      src="assets/img/short_video_editor/sale.png"
                      alt="sale"
                      width={141}
                      height={32}
                    />
                  </div> */}
                </div>

                <TextTypeAiScriptDisplay
                  watch={watch}
                  setValue={setValue}
                  control={control}
                  languageList={languageList}
                  userVoiceList={userVoiceList}
                  userVoiceRefetch={userVoiceRefetch}
                  voiceList={voiceList}
                  voiceRefetch={voiceRefetch}
                  userInfo={userInfo}
                  voiceTags={voiceTags}
                />
                <SubtitleDisplay
                  subTitleList={subTitleList ?? []}
                  watch={watch}
                  control={control}
                  setValue={setValue}
                  userInfo={userInfo}
                  setSubtitleTooltip={setSubtitleTooltip}
                  subtitleTooltip={subtitleTooltip}
                  subtitleColorList={subtitleColorList ?? []}
                />
              </div>
            </ShadowBox>
          </>
          <div className="flex justify-center">
            <p className="text-center">
              패스트컷은 사용자가 제공하는 텍스트/이미지/영상을 토대로 영상을
              만들고 있으며,
              <br />
              AI의 특성상 내용에 실수가 있을 수 있습니다.
              <br />
              지적재산권 침해 여부는 사용자가 확인하여야 하며, 이에 관하여
              패스트컷은 책임이 없습니다.
            </p>
          </div>
          <div className="w-full">
            <button
              className="w-full rounded-full bg-main py-5 text-[18px] font-bold text-white"
              type="submit"
            >
              컨텐츠 영상 생성 요청
            </button>
          </div>
        </form>
      </div>
      {isUseModal && (
        <TextCashUseModal
          isUseModal={isUseModal}
          setUseModal={setUseModal}
          currentPoint={myPointData.totalPoint}
          textVideoInfo={textVideoInfo}
          textVideoPriceInfo={textVideoPriceInfo}
          setSaveSuccessModal={setSaveSuccessModal}
          setValue={setValue}
          getMyPointRefetch={getMyPointRefetch}
          setUploadImages={setUploadImages}
        />
      )}
      {saveSuccessModal && (
        <Modal isModal={saveSuccessModal}>
          <div className="h-[184px] w-[335px] rounded-t-[20px] border-t bg-white p-[20px]">
            <div className="flex h-full flex-col items-center justify-center gap-[24px]">
              <p className="text-[18px] font-bold">요청 완료</p>
              <div>
                <p className="text-[14px] font-bold">
                  컨텐츠 영상 생성이 요청 되었습니다!
                </p>
                <p className="text-[14px] font-bold">
                  생성 현황은 <span className="text-main">‘사용 현황‘</span>{' '}
                  페이지에서 확인하세요.
                </p>
              </div>
            </div>
          </div>
          <div className="flex w-[335px]">
            <div className="flex h-[60px] w-[50%] items-center justify-center rounded-bl-[20px] border-b border-[#EEF1F7] bg-[#EEF1F7]">
              <button
                className="w-full font-bold text-[#5E6068]"
                onClick={() => {
                  navigate('/my-videos?type=tcv&page=1&pageSize=80')
                }}
              >
                사용현황 페이지 가기
              </button>
            </div>
            <div className="flex h-[60px] w-[50%] items-center justify-center rounded-br-[20px] border-b border-main bg-main">
              <button
                className="w-full font-bold text-white"
                onClick={(event) => {
                  setSaveSuccessModal(false)
                }}
              >
                확인
              </button>
            </div>
          </div>
        </Modal>
      )}
      {isErrorModal && (
        <ErrorModal
          isErrorModal={isErrorModal}
          setIsErrorModal={setIsErrorModal}
          errorTitle={errorTitle}
          errorSubtitle={errorSubtitle}
        />
      )}

      {isSceneErrorModal && (
        <SceneErrorModal
          isSceneErrorModal={isSceneErrorModal}
          setIsSceneErrorModal={setIsSceneErrorModal}
        />
      )}
    </>
  )
}
const SceneErrorModal = (props: any) => {
  const { isSceneErrorModal, setIsSceneErrorModal } = props
  return (
    <>
      <Modal isModal={isSceneErrorModal as boolean}>
        <div className="a h-[184px] w-[335px] rounded-t-[20px] border-t bg-white p-[20px]">
          <div className="flex h-full flex-col items-center justify-center gap-[24px]">
            <p className="text-[18px] font-bold">
              🚨4개 이상의 문장을 입력해주세요!
            </p>
            <div>
              <p className="text-[14px]">
                <span className="text-main">마침표</span> '.' 또는{' '}
                <span className="text-main">느낌표</span> '!' 또는 물음표 '?' 를
                사용해서 <br /> 문장 구분이 잘 될 수 있게 작성해주세요!
                <br /> 대본의 문장이 총 4개 이상이 되어야
                <br /> 영상 생성이 가능합니다.
              </p>
            </div>
          </div>
        </div>
        <div className="flex w-[335px]">
          <div className="flex h-[60px] w-[100%] items-center justify-center rounded-b-[20px] border-b border-main bg-main">
            <button
              className="w-full font-bold text-white"
              onClick={(event) => {
                setIsSceneErrorModal(false)
              }}
            >
              확인
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}
const ErrorModal = (props: any) => {
  const { isErrorModal, setIsErrorModal, errorTitle, errorSubtitle } = props
  return (
    <>
      <Modal isModal={isErrorModal as boolean}>
        <div className="h-[184px] w-[335px] rounded-t-[20px] border-t bg-white p-[20px]">
          <div className="flex h-full flex-col items-center justify-center gap-[24px]">
            {errorTitle}
            <div>{errorSubtitle}</div>
          </div>
        </div>
        <div className="flex w-[335px]">
          <div className="flex h-[60px] w-[100%] items-center justify-center rounded-b-[20px] border-b border-main bg-main">
            <button
              className="w-full font-bold text-white"
              onClick={(event) => {
                setIsErrorModal(false)
              }}
            >
              확인
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}
